import(/* webpackMode: "eager" */ "/home/das/web/crowdvault.digitas.my/nodeapp/src/app/campaign-detail/[id]/page.tsx");
